




































































































































































import Vue from 'vue';
import {
  CTA,
  MemberAccountResponseModel,
} from '@/@types/member';

interface Data {
  pageNavExpanded: boolean;
  menuOpen: boolean;
}

export default Vue.extend({
  name: 'PageInternalNav',
  props: {
    navItems: {
      type: Array as () => CTA[],
      required: true,
    },
    showIWantTo: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      pageNavExpanded: false,
      menuOpen: false,
    };
  },
  methods: {
    togglePageNav(): void {
      this.pageNavExpanded = !this.pageNavExpanded;
    },
    navigateToRoute(route): void {
      this.$router.push(route);
    },
  },
  watch: {
    $route() {
      if (this.pageNavExpanded) {
        this.togglePageNav();
      }
    },
  },
  computed: {
    account(): MemberAccountResponseModel {
      return this.$store.getters.currentAccount(this.$route.params.id);
    },
    hasActiveHSA(): boolean {
      return this.$store.getters.hasActiveHSA;
    },
    hasAllowCards(): boolean {
      return this.$store.getters.hasAllowCards;
    },
    isNonMigrated(): boolean {
      return this.account.isMigratedInd === false;
    },
    isHSA(): boolean {
      return this.account.productType === 'HSA';
    },
    isTRA(): boolean {
      return this.account.productType === 'TRA';
    },
    isAAP(): boolean {
      return this.account.productType === 'AAP';
    },
    // MBR-011: BR-1.02
    showMakeDeposit(): boolean {
      return this.isHSA && this.isNonMigrated;
    },
    showPayBill(): boolean {
      return this.isTRA && this.isAAP && this.isNonMigrated;
    },
    showManageCard(): boolean {
      return this.hasAllowCards && this.isNonMigrated;
    },
    showManageBank(): boolean {
      return this.isNonMigrated;
    },
    showIWantTo(): boolean {
      // null checking this.account since this component is used on payment and banking screen which is not an account specific route
      return this.account && this.showMakeDeposit && this.showPayBill && this.showManageCard && this.showManageBank;
    },
  },
});
